export const PASTORS = [
    {
        name: "Edir Macedo",
        wealth: "$1.2 billion",
        description: "Edir Macedo is the founder of the Universal Church of the Kingdom of God and owner of Rede Record, one of Brazil's largest television networks.",
        country: "Brazil",
        profile: "/pastors/Edir_Macedo.jpg"
    },
    {
        name: "Alph Lukau",
        wealth: "$1 billion",
        description: "Alph Lukau is the founder of Alleluia Ministries International, known for his charismatic preaching and global reach.",
        country: "South Africa"
    },
    {
        name: "Valdemiro Santiago",
        wealth: "$350 million",
        description: "Valdemiro Santiago leads the World Church of the Power of God, one of the fastest-growing evangelical movements in Brazil.",
        country: "Brazil"
    },
    {
        name: "Kenneth Copeland",
        wealth: "$300 million",
        description: "Kenneth Copeland is an American televangelist and founder of Kenneth Copeland Ministries, renowned for his prosperity gospel teachings.",
        country: "USA"
    },
    {
        name: "David Oyedepo",
        wealth: "$150 million",
        description: "David Oyedepo is the founder of Living Faith Church Worldwide, also known as Winners' Chapel, and a proponent of the prosperity gospel.",
        country: "Nigeria"
    },
    {
        name: "Shepherd Bushiri",
        wealth: "$150 million",
        description: "Shepherd Bushiri is the founder of Enlightened Christian Gathering, a South African megachurch with a large following across Africa.",
        country: "South Africa"
    },
    {
        name: "Pat Robertson",
        wealth: "$100 million",
        description: "Pat Robertson is the founder of the Christian Broadcasting Network and a prominent figure in American televangelism.",
        country: "USA"
    },
    {
        name: "Joel Osteen",
        wealth: "$100 million",
        description: "Joel Osteen is the senior pastor of Lakewood Church, the largest congregation in the USA, known for his inspirational messages.",
        country: "USA",
        profile: "/pastors/Joel_Osteen.jpg"
    },
    {
        name: "Chris Oyakhilome",
        wealth: "$126 million",
        description: "Chris Oyakhilome is the founder of Christ Embassy, also known as Believers' LoveWorld, with a strong presence in Africa and beyond.",
        country: "Nigeria"
    },
    {
        name: "Benny Hinn",
        wealth: "$60 million",
        description: "Benny Hinn is an Israeli-born televangelist renowned for his 'Miracle Crusades' and healing ministry.",
        country: "USA"
    },
    {
        name: "David Jeremiah",
        wealth: "$55 million",
        description: "David Jeremiah is the senior pastor of Shadow Mountain Community Church and founder of Turning Point Ministries, a global media ministry.",
        country: "USA"
    },
    {
        name: "Romildo Ribeiro Soares (R.R. Soares)",
        wealth: "$125 million",
        description: "R.R. Soares is a Brazilian televangelist and founder of the International Church of God's Grace, a popular evangelical denomination in Brazil.",
        country: "Brazil"
    },
    {
        name: "Steven Furtick",
        wealth: "$60 million",
        description: "Steven Furtick is the founder and lead pastor of Elevation Church, known for his dynamic preaching and contemporary worship style.",
        country: "USA"
    },
    {
        name: "Creflo Dollar",
        wealth: "$30 million",
        description: "Creflo Dollar is the founder of World Changers Church International and a prominent advocate of the prosperity gospel.",
        country: "USA"
    },
    {
        name: "Rick Warren",
        wealth: "$25 million",
        description: "Rick Warren is the founder of Saddleback Church and author of the bestselling book 'The Purpose Driven Life.'",
        country: "USA"
    },
    {
        name: "T.D. Jakes",
        wealth: "$20 million",
        description: "T.D. Jakes is the founder of The Potter's House, a Dallas-based megachurch, and a prominent author and filmmaker.",
        country: "USA"
    },
    {
        name: "Bill Hybels",
        wealth: "$40 million",
        description: "Bill Hybels is the founder of Willow Creek Community Church, known for pioneering the seeker-sensitive church movement.",
        country: "USA"
    },
    {
        name: "Joyce Meyer",
        wealth: "$8 million",
        description: "Joyce Meyer is the founder of Joyce Meyer Ministries, a global ministry focused on practical Bible teaching.",
        country: "USA"
    },
    {
        name: "Joseph Prince",
        wealth: "$5 million",
        description: "Joseph Prince is the senior pastor of New Creation Church in Singapore and a prominent voice in the grace movement.",
        country: "Singapore"
    },
    {
        name: "Franklin Graham",
        wealth: "$10 million",
        description: "Franklin Graham is the president of the Billy Graham Evangelistic Association and Samaritan's Purse, continuing his father's evangelical legacy.",
        country: "USA"
    }
];
